import React, { useState, useEffect } from 'react';
import IconNoData from '../../assets/Images/icons/icon-no-data';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip, Table, Switch, Form, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FormOutlined } from '@ant-design/icons';
import { DeleteFilled } from '@ant-design/icons';
import ModalAddCookie from './components/ModalAddCookie';
import ModalConfirm from '../../components/Shared/modal/confirm';
import IconChangeToggle from '../../assets/Images/icons/icon-change-toggle';
import CookieManagementService from '../../services/CookieManagement.service';
import useNotify from '../../context/Notification/useNotify';
import ModalDelete from '../../components/Shared/modal/delete';
import usePermission from '../../hooks/usePermission';

export default function CatetoryDetail({
    categoryList,
    selectCategory,
    domainList,
    domainSelect,
    cookieList,
    getCategoryDetail,
    setAllCategoryList,
    setCategoryList,
    setSelectCategory,
    loadingStatus,
}) {
    const { isAuditor, isUser } = usePermission();

    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const notify = useNotify();
    const [form] = Form.useForm();
    const [showModal, setShowModal] = useState(false);
    const [cookieDetail, setCookieDetail] = useState(false);
    const [isActive, setIsActive] = useState(selectCategory?.isActive);
    const [categoryCurrent, setCategoryCurrent] = useState();
    const [cookieIdDelete, setCookieIdDelete] = useState();
    // Confirm Delete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    // Confirm Active/InActive
    const [openConfirmInActive, setOpenConfirmInActive] = useState(false);

    const columns = [
        {
            title: t('Name'),
            dataIndex: 'cookieName',
            key: 'cookieName',
            width: '40%',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <>
                        <div className="font-semibold">{row.cookieName}</div>
                        <div>{row.description}</div>
                    </>
                );
            },
        },
        {
            title: t('COOKIE.DomainURL'),
            dataIndex: 'domain',
            key: 'domain',
            width: '20%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.Duration'),
            dataIndex: 'duration',
            key: 'duration',
            width: '15%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('Action'),
            key: 'action',
            align: 'center',
            width: '15%',
            render: (text, record) => (
                <div className="whitespace-nowrap">
                    <Tooltip
                        placement="bottom"
                        title={t('Edit')}
                        className="cursor-pointer"
                    >
                        <Button
                            disabled={isAuditor || isUser}
                            type="button"
                            className="border-none bg-[#F3F6F9] text-[#7B67FB]"
                            onClick={() => {
                                setShowModal(true);
                                setCookieDetail(record);
                            }}
                            icon={<FormOutlined />}
                        />
                    </Tooltip>
                    <Tooltip
                        placement="bottom"
                        title={t('Delete')}
                        className="cursor-pointer"
                    >
                        <Button
                            disabled={isAuditor || isUser}
                            type="button"
                            className="border-none bg-[#F3F6F9] ml-2 text-[#7B67FB]"
                            onClick={() => {
                                setOpenConfirmDelete(true);
                                setCookieIdDelete(record?.cookieDetailId);
                            }}
                            icon={<DeleteFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    useEffect(() => {
        if (selectCategory) {
            form.setFieldsValue(selectCategory);
            setCategoryCurrent(selectCategory);
            setIsActive(selectCategory?.isActive);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectCategory]);

    const getCookieCategoryList = async (companyId, domainId) => {
        try {
            const { data } =
                await CookieManagementService.getCookieCategoryList({
                    domainId,
                    companyId,
                });
            if (data?.resultData) {
                const item = data?.resultData;
                const general = item?.general;
                const unclassify = item?.unclassify;
                setAllCategoryList(general.concat(unclassify));
                setCategoryList(item);
                await setSelectCategory(categoryCurrent);
            }
        } catch (err) {
            setCategoryList([]);
            console.log(err);
        }
    };

    return (
        <>
            {loadingStatus === true ? (
                <>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-span-6 text-[20px] text-[#171717] font-semibold">
                            {lang === 'en'
                                ? selectCategory?.categoryNameEn
                                : selectCategory?.categoryNameTh}
                        </div>
                        <div className="col-span-5 text-[14px] text-[#65707A]">
                            {lang === 'en'
                                ? selectCategory?.descriptionEn
                                : selectCategory?.descriptionTh}
                        </div>
                        <div className="text-right text-[14px] font-medium">
                            <Button
                                disabled={isAuditor || isUser}
                                size="large"
                                type="primary"
                                onClick={() => {
                                    setShowModal(true);
                                }}
                            >
                                <PlusOutlined /> {t('COOKIE.AddCookie')}
                            </Button>
                        </div>
                    </div>

                    <div
                        className="my-4"
                        style={{ borderBottom: '1px solid #F2F2F2' }}
                    ></div>
                    <div className="p-2">
                        {/* initialValues={{isActive : true}} */}
                        <Form
                            disabled={isAuditor || isUser}
                            form={form}
                            layout="vertical"
                        >
                            <div className="flex space-x-2 justify-end text-right">
                                <div className="my-1 font-semibold text-[#65707A]">
                                    {isActive
                                        ? t('CookieCategory.Active')
                                        : t('CookieCategory.InActive')}{' '}
                                </div>
                                <div>
                                    <Form.Item
                                        name="isActive"
                                        valuePropName="checked"
                                    >
                                        <Switch
                                            defaultChecked
                                            onChange={async (value) => {
                                                // console.log('value change :: ', value)
                                                if (value === true) {
                                                    CookieManagementService.HiddenCookie(
                                                        {
                                                            categoryId:
                                                                selectCategory?.cookieCategoryId,
                                                            isEnable: true,
                                                        }
                                                    )
                                                        .then(async (res) => {
                                                            setIsActive(value);
                                                            setOpenConfirmInActive(
                                                                false
                                                            );
                                                            notify({
                                                                title: t(
                                                                    'common.Success'
                                                                ),
                                                                description: t(
                                                                    'Successfully updated data'
                                                                ),
                                                                duration: 0.5,
                                                            });
                                                            form.setFieldsValue(
                                                                {
                                                                    isActive:
                                                                        value,
                                                                }
                                                            );
                                                            await getCookieCategoryList(
                                                                domainSelect?.companyId,
                                                                domainSelect?.domainId
                                                            );
                                                        })
                                                        .catch((err) => {
                                                            setIsActive(value);
                                                            setOpenConfirmInActive(
                                                                false
                                                            );
                                                            notify({
                                                                type: 'error',
                                                                title: t(
                                                                    'common.Fail'
                                                                ),
                                                                description: t(
                                                                    'Failed to updated data'
                                                                ),
                                                            });
                                                            form.setFieldsValue(
                                                                {
                                                                    isActive: false,
                                                                }
                                                            );
                                                        });
                                                } else {
                                                    // form.setFieldsValue({ isActive: false })
                                                    setIsActive(false);
                                                    setOpenConfirmInActive(
                                                        true
                                                    );
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {/* checkedChildren="เปิด" unCheckedChildren="ปิด"*/}
                                </div>
                            </div>
                        </Form>
                        <Spin spinning={!cookieList}>
                            {cookieList?.length > 0 ? (
                                <div className="mt-6 mb-10">
                                    <Table
                                        className="inbox_table"
                                        dataSource={cookieList}
                                        columns={columns}
                                        pagination={false}
                                        scroll={{
                                            y: 340,
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className="text-center text-sm space-y-2 my-32">
                                    <IconNoData />
                                    <p className="text-[#65707A] text-[14px]">
                                        {t('common.noData')}
                                    </p>
                                </div>
                            )}
                        </Spin>
                    </div>
                </>
            ) : (
                <div className="text-center text-sm space-y-2 my-64">
                    <IconNoData />
                    <p className="text-[#65707A] text-[14px]">
                        {t('common.noData')}
                    </p>
                </div>
            )}

            <ModalAddCookie
                open={showModal}
                handelClose={() => setShowModal(false)}
                setCookieDetail={setCookieDetail}
                cookieDetail={cookieDetail}
                categoryName={
                    lang === 'en'
                        ? selectCategory?.categoryNameEn
                        : selectCategory?.categoryNameTh
                }
                domainList={domainList}
                domainSelect={domainSelect}
                getCategoryDetail={getCategoryDetail}
                categoryList={categoryList}
                cookieCategoryId={categoryCurrent?.cookieCategoryId}
            />
            <ModalDelete
                title={t('common.ConfirmDelete')}
                text={t('COOKIE.DoYouWantToDeleteCookie')}
                open={openConfirmDelete}
                handelOk={async () => {
                    try {
                        const { data } =
                            await CookieManagementService.deleteCookie(
                                cookieIdDelete
                            );
                        if (data?.resultCode === 1) {
                            setOpenConfirmDelete(false);
                            notify({
                                title: t('common.Success'),
                                description: t('Successfully deleted data'),
                            });
                            getCategoryDetail();
                        } else {
                            if (
                                data?.errorData?.msg ===
                                'COOKIE DETAIL IS NOT MANUAL'
                            ) {
                                setOpenConfirmDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('COOKIE.FailDeleteCookie'),
                                    description: t(
                                        'COOKIE.FailDeleteCookieTitle'
                                    ),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            } else {
                                setOpenConfirmDelete(false);
                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('common.FailedDeleteData'),
                                    timeOut: 120000,
                                    closeable: true,
                                });
                            }
                        }
                    } catch (err) {
                        console.log(err);
                        if (
                            err?.data?.errorData?.msg ===
                            'COOKIE DETAIL IS NOT MANUAL'
                        ) {
                            setOpenConfirmDelete(false);
                            notify({
                                type: 'error',
                                title: t('COOKIE.FailDeleteCookie'),
                                description: t('COOKIE.FailDeleteCookieTitle'),
                                timeOut: 120000,
                                closeable: true,
                            });
                        } else {
                            setOpenConfirmDelete(false);
                            notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('common.FailedDeleteData'),
                                timeOut: 120000,
                                closeable: true,
                            });
                        }
                    }
                }}
                handelClose={() => setOpenConfirmDelete(false)}
            />

            <ModalConfirm
                title={t('COOKIE.DeactivateCookieCategory')}
                text={t('COOKIE.TextConfirm')}
                open={openConfirmInActive}
                icon={<IconChangeToggle />}
                handelOk={async () => {
                    try {
                        const { data } =
                            await CookieManagementService.HiddenCookie({
                                categoryId: selectCategory?.cookieCategoryId,
                                isEnable: false,
                            });
                        if (data?.resultCode === 1) {
                            setIsActive(false);
                            setOpenConfirmInActive(false);
                            notify({
                                title: t('common.Success'),
                                description: t('Successfully updated data'),
                                duration: 0.5,
                            });
                            await getCookieCategoryList(
                                domainSelect?.companyId,
                                domainSelect?.domainId
                            );
                            form.setFieldsValue({ isActive: false });
                        } else {
                            setIsActive(true);
                            setOpenConfirmInActive(false);
                            notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('Failed to updated data'),
                                timeOut: 120000,
                                closeable: true,
                            });
                            form.setFieldsValue({ isActive: true });
                        }
                    } catch (err) {
                        setIsActive(true);
                        setOpenConfirmInActive(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to updated data'),
                            timeOut: 120000,
                            closeable: true,
                        });
                        form.setFieldsValue({ isActive: true });
                    }
                }}
                handelClose={() => {
                    form.setFieldsValue({ isActive: true });
                    setIsActive(true);
                    setOpenConfirmInActive(false);
                }}
            />
        </>
    );
}
